import { Component } from 'react';

// eslint-disable-next-line react/prefer-stateless-function
class FriendScanner extends Component {
  render() {
    return null;
  }
}

export default FriendScanner;
